import React, { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import { coinsToINR, formatCoins, formatINR } from "./revenueSummaryUtils";

const EarningsDistributionChart = ({ data }) => {
	const [showTable, setShowTable] = useState(false);
	const chartData = (data || []).filter((item) => item.coins > 0 || item.percentage > 0);

	const CustomTooltip = ({ active, payload }) => {
		if (!active || !payload?.length) return null;
		const item = payload[0].payload;
		return (
			<div className="rs-chart-tooltip">
				<div className="rs-chart-tooltip-title">{item.name}</div>
				<div className="rs-chart-tooltip-meta">
					{formatCoins(item.coins)} ({item.percentage}%)
				</div>
				<div className="rs-chart-tooltip-inr">≈ {formatINR(coinsToINR(item.coins))}</div>
			</div>
		);
	};

	const totals = chartData.reduce(
		(acc, item) => ({ coins: acc.coins + (item.coins ?? 0), count: acc.count + (item.count ?? 0) }),
		{ coins: 0, count: 0 }
	);

	return (
		<div>
			<div className="rs-chart-header">
				<h3 className="rs-chart-title">Earnings by Type</h3>
				<button
					type="button"
					onClick={() => setShowTable(!showTable)}
					className={`rs-chart-toggle ${showTable ? "rs-chart-toggle--active" : "rs-chart-toggle--inactive"}`}
				>
					{showTable ? "Show Chart" : "Show Table"}
				</button>
			</div>

			{chartData.length > 0 ? (
				!showTable ? (
					<ResponsiveContainer width="100%" height={500}>
						<PieChart>
							<Pie data={chartData} cx="50%" cy="50%" outerRadius={120} dataKey="coins"
								label={({ percentage }) => (percentage >= 3 ? `${percentage}%` : "")}
							>
								{chartData.map((entry, index) => (
									<Cell key={`cell-${index}`} fill={entry.color || "#3B82F6"} />
								))}
							</Pie>
							<Tooltip content={<CustomTooltip />} />
							<Legend />
						</PieChart>
					</ResponsiveContainer>
				) : (
					<div className="rs-table-scroll">
						<table className="admin-table-v4">
							<thead>
								<tr>
									<th>Type</th>
									<th className="rs-text-right">Coins</th>
									<th className="rs-text-right">INR Equivalent</th>
									<th className="rs-text-right">Share %</th>
								</tr>
							</thead>
							<tbody>
								{chartData.map((item, idx) => (
									<tr key={idx}>
										<td>
											<div className="rs-chart-type-row">
												<div
													className="rs-chart-color-dot rs-chart-color-dot--table"
													style={{ "--rs-dot-color": item.color || "#3B82F6" }}
												/>
												{item.name}
											</div>
										</td>
										<td className="rs-text-right rs-text-bold">{formatCoins(item.coins)}</td>
										<td className="rs-text-right rs-table-inr-equiv">{formatINR(coinsToINR(item.coins))}</td>
										<td className="rs-text-right">{item.percentage}%</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr className="rs-table-foot-row">
									<td>TOTAL</td>
									<td className="rs-text-right">{formatCoins(totals.coins)}</td>
									<td className="rs-text-right">{formatINR(coinsToINR(totals.coins))}</td>
									<td className="rs-text-right">100%</td>
								</tr>
							</tfoot>
						</table>
					</div>
				)
			) : (
				<div className="rs-empty">No earnings data available</div>
			)}
		</div>
	);
};

export default EarningsDistributionChart;
